import { Box } from '@mui/material';
import React, { ReactElement } from 'react';

import { ContentIconLinkList } from '../../../models';
import { Node } from '../../consumers/Consumer/Consumer';
import { AccessibilityLink } from './AccessibilityLink';

interface Props {
  node: ContentIconLinkList;
  renderNode: (node: Node) => ReactElement;
}

export const AccessibilityLinks: React.FunctionComponent<Props> = ({ node, renderNode }: Props) => {
  if (!node || !node.items || !node.items.length) {
    return null;
  }

  return (
    <Box display="flex" gap={{ xs: 6, lg: 7 }}>
      {node.items.map((item) => (
        <Box flexGrow={1} key={item.id} display="flex" alignItems="center" justifyContent="center">
          <AccessibilityLink node={item} renderNode={renderNode} />
        </Box>
      ))}
    </Box>
  );
};
